import React, { Component } from 'react';
import { Card, Alert } from 'react-bootstrap';

import { AgGridReact } from 'ag-grid-react';
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";

import axios from 'axios';
import Config from "context/config";

import RevisionDetailsView from 'components/controls/RevisionDetailsView/index';
import InfoTooltip from 'components/controls/InfoTooltip/index'

import DownloaderView from './downloader';
import './index.css';

import RecordNlpFormat from './formats/record';
import MultiRcNlpFormat from './formats/multirc';
import SchemaNlpFormat from './formats/schema';

export default class DatasetPreview extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activateObject: this.activateObject,
      activeObjectIndex: null,
      activeObjectDescr: null,
      activeObjectData: null,
      activeObjectRecords: null,
      activeRecordQuery: null
    };

    // this.format is decided here when possible, or deferred to the first loaded row -- see
    // createFormat() and detectRowFormat() below.
    this.format = null;
    this.createFormat();
  }

  componentDidMount() {
    this.activateInitial(0);
  }

  // blobhub.dataset.nlp carries no `format` any more (the contract dropped it, with nothing to
  // replace it — see docs/specs/2026-09-09-blob-type-strings.md), so detection now reads the
  // dataset's own shape instead of a declared field, in two stages because the manifest alone
  // does not always carry enough to decide:
  //
  //   1. Here, from the manifest (this.props.shell.data): a `schema` block is unambiguous and
  //      known before any row loads, so schema-format datasets are decided immediately.
  //   2. In loadObject() below, from the first loaded row: `record` and `multirc` share an
  //      identical manifest (both just list train/val/test.jsonl, no schema block), so telling
  //      them apart needs an actual row. A `passage` object with a `questions` array is unique
  //      to multirc (see formats/multirc.js's expandedRowRender, which reads exactly that path);
  //      a record row's `passage` has no `questions`. Anything else -- including an empty or
  //      not-yet-loaded row list -- defaults to `record`, the most permissive renderer.
  createFormat() {
    if (this.props.shell.data.schema) {
      this.format = new SchemaNlpFormat(this, this.props.shell.data);
    }
  }

  // See createFormat() above -- stage 2. Only called when stage 1 left this.format undecided.
  detectRowFormat(firstRecord) {
    const isMultiRc = !!(firstRecord && firstRecord.passage && Array.isArray(firstRecord.passage.questions));
    return isMultiRc
      ? new MultiRcNlpFormat(this, this.props.shell.data)
      : new RecordNlpFormat(this, this.props.shell.data);
  }

  /**
   * Object Selection
   */

  activateInitial(index) {
    if ( 0 === this.props.shell.data.objects.length ) {
      return;
    }

    this.state.activeObjectIndex = index;
    this.state.activeObjectDescr = this.props.shell.data.objects[index];

    // NEXT: Add caching
    this.loadObject(index);
  }

  activateObject = (index) => {
    if ( 0 === this.props.shell.data.objects.length ) {
      return;
    }

    this.setState({
      activeObjectIndex: index,
      activeObjectDescr: this.props.shell.data.objects[index]
    });

    // NEXT: Add caching
    this.loadObject(index);
  }

  loadObject(index) {
    const objectDescr = this.props.shell.data.objects[index];
    axios.get(`${Config.staticBaseUrl()}/revisions/${this.props.revision.id}/${objectDescr["path"]}`)
      .then( response => {
        // Convert JSONL into records
        var records = [];
        var dataLines = response.data.split("\n");
        for (var dataLine of dataLines) {
          try {
            var record = JSON.parse(dataLine);
            records.push(record);
          } catch(err) {
            // Not a JSON record. Ignoring for now
          }
        }

        // Decide record vs. multirc from the first row, once -- see createFormat() above.
        // Every object in a dataset (train/val/test) shares one format, so this only runs once.
        if ( !this.format ) {
          this.format = this.detectRowFormat(records[0]);
        }

        // Update component state
        this.setState({
          activeObjectData: response.data,
          activeObjectRecords: records
        });
      })
      .catch( error => {
      }
    );
  }

  /**
   * Rendering section
   */

  render() {
    // this.format may still be undecided -- see createFormat()/detectRowFormat() above -- for
    // as long as the first object hasn't loaded. Rendered the same as "still loading" below,
    // rather than nothing, so there is no blank window before the first row arrives.
    const columns = this.format ? this.format.getColumns() : null;

    return (
      <>
        {this.props.shell.data.objects.length > 0 &&
          <DownloaderView
            app={this.props.app}
            parent={this.state}
            blob={this.props.blob}
            revision={this.props.revision}
            shell={this.props.shell}
          />
        }

        <Card>
          <Card.Header>
            {this.props.revision
              ? <RevisionDetailsView
                  app={this.props.app}
                  revision={this.props.revision}
                  shell={null}
                />
              : <Alert variant="primary" className="mb-0">Loading revision info...</Alert>
            }
          </Card.Header>
          <Card.Body>
            {(this.state.activeObjectRecords && columns) ? (
              <div
                className="ag-theme-quartz"
                style={{ height: "700px" }}
              >
                <AgGridReact
                  rowData={this.state.activeObjectRecords}
                  columnDefs={columns}
                  pagination={true}
                  paginationPageSize={20}
                  paginationPageSizeSelector={[20, 50, 100]}
                />
              </div>
            ) : (
              <Alert variant="primary">Loading object...</Alert>
            )}
          </Card.Body>
        </Card>
      </>
    )
  }
}
